import {getDeliveryCommunes} from '../../Utils/api'

const SET_COMMUNES = 'SET_COMMUNES'

const initialState = {
  communes: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_COMMUNES:
      return {
        ...state,
        communes: action.communes,
      }
    default:
      return state
  }
}

export function setCommunes(communes) {
  return {
    type: SET_COMMUNES,
    communes,
  }
}

export function fetchCommunes() {
  return async (dispatch) => {
    getDeliveryCommunes()
      .then((el) => {
        dispatch(setCommunes(el?.data ? el?.data : []))
      })
      .catch(console.log)
  }
}
